// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"96db05ca","351":"e8a90c59","503":"6b7f95f2","574":"1f969499","579":"3a9d6c5f","674":"057f2f96","787":"a056c3c9","806":"d704872b"}[chunkId] + ".chunk.js";
};